module.exports = __webpack_public_path__ + "img/pålestikk3.05e6a903.jpg";